import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type QuoteVariantInput = TrpcInputs['updateQuoteVariant'];
type QuoteVariantOutput = TrpcOutputs['updateQuoteVariant'];

type MutateQuoteVariant = MutateFunction<QuoteVariantInput, QuoteVariantOutput>;
type UseUpdateQuoteVariant = UseMutateResource<MutateQuoteVariant>;

export const useUpdateQuoteVariant = (id?: number): UseUpdateQuoteVariant => {
  const { mutateAsync, isLoading, error } = trpc.updateQuoteVariant.useMutation();

  const mutate: MutateQuoteVariant = (args) => mutateAsync({ id, ...args } as QuoteVariantInput);

  return [mutate, isLoading, error?.message];
};
